<template>
  <v-dialog :value="value" max-width="500" persistent @input="$emit('input', $event)">
    <v-card class="confirmed-popup__card" :style="{ 'background-color': backgroundColor }">
      <v-card-title class="confirmed-popup__title" :style="{ color: fontColor }">
        {{ title }}
      </v-card-title>
      <v-card-text class="confirmed-popup__text" :style="{ color: fontColor }">
        {{ description }}
      </v-card-text>
      <v-card-actions class="confirmed-popup__actions">
        <v-spacer></v-spacer>
        <v-btn
          :style="{
            'background-color': buttonBackgroundColor,
            color: buttonFontColor
          }"
          @click="close"
        >
          Fechar
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmedPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    fontColor: {
      type: String,
      default: '#000000'
    },
    buttonBackgroundColor: {
      type: String,
      default: '#1976d2'
    },
    buttonFontColor: {
      type: String,
      default: '#ffffff'
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped lang="scss">
.confirmed-popup__card {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
}

.confirmed-popup__title {
  flex-shrink: 0;
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
  justify-content: center;
  width: 100%;
  padding-top: 24px;
}

.confirmed-popup__text {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  text-align: center;
  padding-bottom: 8px;
  opacity: 0.9;
}

.confirmed-popup__actions {
  flex-shrink: 0;
  padding-bottom: 24px;
}
</style>
